import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import PowerBI from "@/components/PowerBI";
import { hasPowerBiConfigs } from "@/config/environmentUtils";

import DashboardLogo from "./DashboardLogo";

const Dashboard = () => {
  const { t } = useTranslation();
  const isPowerBiVisible = hasPowerBiConfigs();

  return isPowerBiVisible ? (
    <PowerBI title={t("dashboard:powerbi")} />
  ) : (
    <>
      <BaseHeader title={t("navigation:dashboard")} />
      <DashboardLogo />
    </>
  );
};

export default Dashboard;
